import { TYPE_STRING } from './input-types';

export const id = 'source';
export const apiKey = 'Source';
export const type = TYPE_STRING;

export const source = {
  id,
  apiKey,
  type,
};
